/*eslint-disable*/
import { Flex, SquareIcon } from 'styling/GlobalStyles'
import { GlobalViewWidget, GlobalViewWidgetContent, GloblViewWidgetTitle, WidgetBar, WidgetBarContainer, WidgetBarInfoContainer } from '../GlobalView.styled'
import { BodyText, OtherText, ParagraphText } from 'styling/Typography'
import { machineryIcon } from 'assets/icons/MachineryIcon'
import { useSelector } from 'react-redux'
import { RootState } from 'store'

export const GLMachinesWidget = ({ selectedStatus, handleWidget }: { selectedStatus: number, handleWidget: (open: boolean, type: number) => void }) => {
    const { machinery } = useSelector((state: RootState) => state.dashboard)

    const colors = ['#02CB42', '#ff9900', '#FF4F46', '#1CBBFF', '#7E571B']

    const findStatusCount = (status: number) => machinery?.machineStatuses.find(s => s.status == status)?.count || 0


    const getPercentage = (curr: number): string => {
        if (!curr || curr === 0) return '0%';
        return ((curr / machinery?.totalCount || 0) * 100).toString() + '%'
    }


    return <GlobalViewWidget>
        <GloblViewWidgetTitle>
            <SquareIcon color='#ff9900' >
                {machineryIcon}
            </SquareIcon>
            <Flex column >
                <BodyText weight='bold' >Machines</BodyText>
                <OtherText style={{ color: '#ff9900', cursor: 'pointer', width: 'max-content' }} onClick={() => handleWidget(true, null)} > View All </OtherText>
            </Flex>
        </GloblViewWidgetTitle>
        <GlobalViewWidgetContent>
            <WidgetBarContainer selected={selectedStatus == 1} onClick={() => handleWidget(true, 1)}  >
                <WidgetBarInfoContainer >
                    <BodyText >Free</BodyText>
                    <Flex gap='1rem' >
                        {findStatusCount(1) > 0 && <WidgetBar width={getPercentage(findStatusCount(1))} color={colors[0]} />}
                        <ParagraphText  >{findStatusCount(1)}</ParagraphText>
                    </Flex>
                </WidgetBarInfoContainer>
            </WidgetBarContainer>

            <WidgetBarContainer selected={selectedStatus == 2} onClick={() => handleWidget(true, 2)}  >
                <WidgetBarInfoContainer>
                    <BodyText >Busy</BodyText>
                    <Flex gap='1rem' >
                        {findStatusCount(2) > 0 && <WidgetBar width={getPercentage(findStatusCount(2))} color={colors[1]} />}
                        <ParagraphText  >{findStatusCount(2)}</ParagraphText>
                    </Flex>

                </WidgetBarInfoContainer>
            </WidgetBarContainer>

            <WidgetBarContainer selected={selectedStatus == 3} onClick={() => handleWidget(true, 3)}  >
                <WidgetBarInfoContainer  >
                    <BodyText>Broken</BodyText>
                    <Flex gap='1rem' >
                        {findStatusCount(3) > 0 && <WidgetBar width={getPercentage(findStatusCount(3))} color={colors[2]} />}
                        <ParagraphText >{findStatusCount(3)}</ParagraphText>
                    </Flex>

                </WidgetBarInfoContainer>
            </WidgetBarContainer>

            <WidgetBarContainer selected={selectedStatus == 4} onClick={() => handleWidget(true, 4)}  >
                <WidgetBarInfoContainer>
                    <BodyText >Maintenance</BodyText>
                    <Flex gap='1rem' >
                        {findStatusCount(4) > 0 && <WidgetBar width={getPercentage(findStatusCount(4))} color={colors[3]} />}
                        <ParagraphText>{findStatusCount(4)}</ParagraphText>
                    </Flex>

                </WidgetBarInfoContainer>
            </WidgetBarContainer>
            <WidgetBarContainer selected={selectedStatus == 5} onClick={() => handleWidget(true, 5)} >
                <WidgetBarInfoContainer>
                    <BodyText >Paused</BodyText>
                    <Flex gap='1rem' >
                        {findStatusCount(5) > 0 && <WidgetBar width={getPercentage(findStatusCount(5))} color={colors[3]} />}
                        <ParagraphText>{findStatusCount(5)}</ParagraphText>
                    </Flex>
                </WidgetBarInfoContainer>
            </WidgetBarContainer>
        </GlobalViewWidgetContent>
    </GlobalViewWidget>
}